import React, { useCallback } from "react";
import classNames from "classnames";
import "./styles.less";

export const ScrollCard = ({ cardList = [] }) => {
  const HoverText = useCallback((item) => {
    if (!item.hoverText) return null;
    return (
      <div className="customer-hover">
        <div
          className="customer-hover-inner"
          onClick={() => {
            if (item.clickUrl) {
              window.open(item.clickUrl);
            } else {
              window.open("https://www.authing.cn/customer");
            }
          }}
        >
          {item.clickUrl ? (
            <>
              {item.hoverText}
              <i
                className="icon authing-icon authing-arrow-right-line"
                style={{
                  display: "inline-block",
                  marginLeft: 6,
                  color: "inherit",
                  fontSize: 16,
                  position: "relative",
                  top: 0,
                }}
              ></i>
            </>
          ) : (
            item.hoverText
          )}
        </div>
      </div>
    );
  }, []);
  return (
    <>
      <div className="scroll-card">
        <div className="basic-column">
          <div className="scroll-card-logo-warp">
            <div className="scroll-mask"></div>
            {cardList.map((lists) => {
              return (
                <div className="scroll-container">
                  {lists.map((item, index) => {
                    return (
                      <div key={index} className="customer-item">
                        <div
                          className={classNames(
                            "customer-logo",
                            item.content && "customer-logo--small"
                          )}
                        >
                          <img src={item.logo} alt={item.name} />
                        </div>
                        {item.content && (
                          <div className="customer-content">{item.content}</div>
                        )}
                        {HoverText(item)}
                      </div>
                    );
                  })}
                  {lists.map((item, index) => {
                    return (
                      <div key={`${index}-copy`} className="customer-item">
                        <div
                          className={classNames(
                            "customer-logo",
                            item.content && "customer-logo--small"
                          )}
                        >
                          <img src={item.logo} alt={item.name} />
                        </div>
                        {item.content && (
                          <div className="customer-content">{item.content}</div>
                        )}
                        {HoverText(item)}
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};
